import ShopTheProject from '@digital-retail/shop-the-project';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import _ from '../../utils/LodashImports';
import { withProduct } from '../../utils/ProductContext';
import { isShopTheProjectAmbientImageCategory } from '../ImageGallery/ImageGalleryHelper';
import styles from './ShopTheProject.styles';
import { isShopTheProjectAmbientImageEnabled } from './ShopTheProject.utils';
import { useShopTheProject } from './ShopTheProjectHook';

const ShopTheProjectWrapper = ({ activeImageIndex, mainProductImage, ambientImageUrl, appCtx, product, cart }) => {
  const gCategoryId = _.get(product, 'attributes.GSCCategoryId', '');
  const showShopTheProjectModal = _.get(product, 'showShopTheProjectModal', 'false');
  const stpAmbientImagesCategories = _.get(appCtx, 'siteConfig.configurations.shopTheProjectConfig.gCategories', []);
  const ambientImageCategoryEnabled = isShopTheProjectAmbientImageCategory(gCategoryId, stpAmbientImagesCategories);
  const {
    initialPrimaryProducts,
    minComplementaryProducts,
    labels,
    showCoachmark,
    maxComplementaryProducts,
    mainProduct,
    handleAddToCart,
    getSecondaryProducts,
    analytics,
    useAmbientImage,
    getPrimaryProducts,
  } = useShopTheProject({
    activeImageIndex,
    mainProductImage,
    appCtx,
    product,
    cart,
    hasAmbientImage: !!ambientImageUrl && isShopTheProjectAmbientImageEnabled(appCtx),
    ambientImageCategoryEnabled,
  });
  if (initialPrimaryProducts.length < minComplementaryProducts && !useAmbientImage) return null;
  return (
    <>
      <style jsx>{styles}</style>
      <div className="shop-the-project-container" data-testid="shop-the-project-container">
        <ShopTheProject
          labels={labels}
          initialShowCoachmark={showCoachmark}
          initialPrimaryProducts={initialPrimaryProducts.slice(0, maxComplementaryProducts)}
          mainProduct={mainProduct}
          addToCart={handleAddToCart}
          getSecondaryProducts={getSecondaryProducts}
          deviceType={appCtx.deviceType}
          analytics={analytics}
          useLazyLoading={useAmbientImage}
          getPrimaryProducts={getPrimaryProducts}
          ambientImageUrl={ambientImageUrl || mainProductImage}
          showPrimaryProductsModal={showShopTheProjectModal}
        />
      </div>
    </>
  );
};

ShopTheProjectWrapper.propTypes = {
  activeImageIndex: PropTypes.number.isRequired,
  mainProductImage: PropTypes.string.isRequired,
  ambientImageUrl: PropTypes.string.isRequired,
  appCtx: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
};

export { ShopTheProjectWrapper };
export default withProduct(withApplicationContext(withCart(ShopTheProjectWrapper)));
